"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Spacer = void 0;

var _react = _interopRequireDefault(require("react"));

var _Box = require("../../elements/Box");

var _excluded = ["x", "y"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**
 * Used to inject space where it's needed.
 */
var Spacer = function Spacer(_ref) {
  var x = _ref.x,
      y = _ref.y,
      restProps = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_react.default.createElement(_Box.Box, _extends({}, restProps, {
    ml: x,
    mt: y
  }));
};

exports.Spacer = Spacer;
Spacer.displayName = "Spacer";
Spacer.displayName = "Spacer";
//# sourceMappingURL=Spacer.js.map